import { useContext } from 'react';
import ConfigContext from '../contexts/ConfigContext';
import AppContext from './../contexts/AppContext';
import ClickToAction from '../components/ClickToAction';

import icon from './../images/logo-icon.svg';
import iconEnphase from './../images/success/logo_enphase_white.png';
import iconLanderConceptMobile from './../images/logo-icon-orange.svg';

export default function Layout({
  addPadding = true,
  children,
  className = '',
  hideClickToCall = false
}: any) {
  const { isDebrandedVersion, features } = useContext(ConfigContext);
  const { deBrandedDomain, showClickToCall, ISRAppointmentDetails } =
    useContext(AppContext);

  const LogoImage = ({ useLanderConceptMobileIcon = false }) => {
    return (
      <img
        alt={`${isDebrandedVersion ? deBrandedDomain.domain : 'Enphase'}`}
        src={
          isDebrandedVersion
            ? deBrandedDomain.logoUrl
            : features.showLanderConcept
            ? useLanderConceptMobileIcon
              ? iconLanderConceptMobile
              : iconEnphase
            : icon
        }
        className={`ml-[24px] md:ml-20 ${
          features.showSunnyBot
            ? 'h-[24px] md:h-[30px]'
            : isDebrandedVersion
            ? 'h-[36px]'
            : 'h-6'
        }`}
      />
    );
  };

  return (
    <div className={className}>
      <div
        className={`${
          features.showSunnyBot ? 'h-[60px]' : 'h-[68px]'
        } md:h-[54px] ${
          features.showSunnyBot
            ? 'bg-white'
            : isDebrandedVersion
            ? 'bg-white border-b border-b-slate-200'
            : 'bg-black'
        }`}>
        <div className="max-w-[1440px] flex h-full mx-auto items-center justify-between">
          <div className="md:hidden">
            <LogoImage useLanderConceptMobileIcon={true}></LogoImage>
          </div>
          <div className="hidden md:block">
            <LogoImage useLanderConceptMobileIcon={false}></LogoImage>
          </div>
          {showClickToCall && !window.leadId && !ISRAppointmentDetails && !hideClickToCall ? (
            <ClickToAction></ClickToAction>
          ) : null}
        </div>
      </div>
      <div className={addPadding && !features.showSunnyBot ? 'px-6' : ''}>
        {children}
      </div>
    </div>
  );
}
